module.exports = __webpack_public_path__ + "static/fishball-7401c198d95849a5bf565eb2c6ad5d1c.jpg";